import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=5465daa6&"
import script from "./Table.vue?vue&type=script&lang=babel&"
export * from "./Table.vue?vue&type=script&lang=babel&"
import style0 from "./Table.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports